module.exports = __webpack_public_path__ + "static/img/syyBottomNew2.c69e799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/syyBottomNew2.png
// module id = 2OR9
// module chunks = 0